<template>
  <div>
    <modalWindow v-if="moveArchiveModal" @close="moveArchiveModal = false" width="600">
      <div class="titlebar">Verplaats archief '{{ currentPort }}'</div>
      <div class="card" style="padding: 10px; 0 10px 10px;">
        <form @submit.prevent style="inset">
          <div class="edit-row">
            <div class="edit-input">
              <span>Naar</span>
              <input
                type=text v-model="newport"
                placeholder="nieuwe of bestaande naam van archief"
              />
            </div>
          </div>
          <div class="edit-row submit-row">
            <input type="submit" @click="moveArchive" value="Archief verplaatsen"/>
          </div>
        </form>
      </div>
    </modalWindow>

    <modalWindow v-if="moveFileModal" @close="moveFileModal = false" width="600">
      <div class="titlebar">
        Verplaats file '{{ currentFile }}' van archief '{{ currentPort }}'
      </div>
      <div class="card" style="padding: 10px; 0 10px 10px;">
        <form @submit.prevent style="inset">
          <div class="edit-row">
            <div class="edit-input">
              <span>Naar</span>
              <input
                type=text v-model="newport"
                placeholder="nieuwe of bestaande naam van archief"
              />
            </div>
          </div>
          <div class="edit-row submit-row">
            <input type="submit" @click="moveFile" value="Bestand verplaatsen"/>
          </div>
        </form>
      </div>
    </modalWindow>

    <div class="row menubar">
      <input
        type=text
        ref="search"
        placeholder="Zoeken op port nr."
        @keyup="updateSearch"
        class="searchbar"
        @keyup.enter="getFiles()"
      />
      <button @click="getFiles()">
        <awesomeIcon icon="search" />
      </button>
      <button v-if="currentPort" @click="moveArchiveModal = !moveArchiveModal">
        Verplaats archief
      </button>
      <div v-if="currentPort" style="float: right">
        <label
          for="archiveUploadfile"
          class="file-label button"
          style="display: nline-block; height:initial"
        >
          <awesomeIcon icon="upload"/> Bestand uploaden
        </label>
        <input
          style="display:none;"
          ref="files"
          id="archiveUploadfile"
          type="file"
          name="img"
          multiple
          @change="uploadFiles()"
        >
      </div>
    </div>

    <div class="msg">
      <awesomeIcon icon="exclamation-circle" />
      Om het desbetreffende archief op te halen: vult u het portefeuillenummer in en klikt u op
      <b><awesomeIcon icon="search" /></b>.
    </div>

    <div v-if="currentPort" class="row menubar">
      <input
        type=text
        v-model="searchName"
        placeholder="Zoeken op naam in port nr."
        @keyup="updateSearch"
        class="searchbar"
      />
      <span>Van:</span>
      <input
        type="date"
        v-model="dateStart"
        @change="updateSearch"
        class="datebar"
      />
      <span>Tot:</span>
      <input
        type="date"
        v-model="dateEnd"
        @change="updateSearch"
        class="datebar"
      />
      <inputDropdown
        :array="bestandType"
        v-model="bestandsFormat"
        displayPrefix="Type: "
        style="float:right"
        :cb="dropdownCB"
      />
    </div>

    <div class="card" v-if="files.length > 0">
      <table>
        <thead class="table-legend">
          <tr>
            <th>Bestandsnaam</th>
            <th
              colspan="2"
              width="20%"
            >Upload datum</th>
            <th
              colspan="3"
              width="30%"
              style="text-align:center;"
            />
          </tr>
        </thead>
        <tr
          v-for="file in
             filter(filter(filter(files, fileFilter),dateFilter),searchFilter).slice(
            currentPage * resultsPerPage,
            (currentPage + 1) * resultsPerPage
          )"
          :key="file.path"
        >
          <td>{{ file.cleanPath }}</td>
          <td>
            {{ new Date(file.uploaded).toLocaleDateString() }}
          </td>
          <td>
            {{ new Date(file.uploaded).toLocaleTimeString() }}
          </td>
          <td>
            <button
                class="secondary"
                @click="currentFile = file.path;moveFileModal = !moveFileModal"
              >
                Verplaats
            </button>
          </td>
          <td>
            <button
                class="secondary"
                @click="download(file.path)"
              >
                <awesomeIcon icon="download"/> Download
            </button>
          </td>
          <td>
            <button
              class="secondary"
              @click="deleteFile(file.path)"
            >
              <awesomeIcon icon="times"/> Verwijder
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
          v-model="currentPage"
          :records="
            filter(
              filter(filter(filter(files, fileFilter),dateFilter),searchFilter),
            ).length
          "
          :resultsPerPage="resultsPerPage"
        />
    </div>

    <div v-else-if="!searching && search && currentPort === search" class="noresults">
      <span>Geen bestanden in portefeuille</span>
    </div>

    <div v-else-if="!searching" class="noresults">
      <span>Zoeken op portefeuille</span>
    </div>

    <div v-else class="loader"/>
  </div>
</template>

<script>
import {
  orderBy, filter,
} from 'lodash-es';

export default {
  name: 'AdminArchive',
  data() {
    return {
      currentPort: '',
      dateStart: null,
      dateEnd: null,
      searching: false,
      searchName: null,
      moveArchiveModal: false,
      moveFileModal: false,
      search: '',
      newport: '',
      currentFile: '',
      files: [],
      currentPage: 0,
      resultsPerPage: 20,
      bestandsFormat: 'alles',
      bestandType: [
        {
          value: 'alles',
          label: 'Alles',
        },
        {
          value: 'pdf',
          label: 'Pdf',
        },
        {
          value: 'txt',
          label: 'Text',
        },
        {
          value: 'msg',
          label: 'Mail',
        },
        {
          value: 'xml',
          label: 'Xml',
        },
        {
          value: 'images',
          label: 'Afbeeldingen',
        },
        {
          value: 'docs',
          label: 'Word',
        },
        {
          value: 'excel',
          label: 'Excel',
        },
        {
          value: 'overige',
          label: 'Overige',
        },
      ],
    };
  },
  methods: {
    filter,
    dropdownCB() {
      this.currentPage = 0;
    },
    fileFilter(obj) {
      if (this.bestandsFormat === 'alles') {
        return true;
      }
      if (this.bestandsFormat === 'pdf' && obj.path.toLowerCase().substr(-3) === 'pdf') {
        return true;
      }
      if (this.bestandsFormat === 'txt' && obj.path.toLowerCase().substr(-3) === 'txt') {
        return true;
      }
      if (this.bestandsFormat === 'msg' && obj.path.toLowerCase().substr(-3) === 'msg') {
        return true;
      }
      if (this.bestandsFormat === 'xml' && obj.path.toLowerCase().substr(-3) === 'xml') {
        return true;
      }
      if (this.bestandsFormat === 'images'
        && (
          obj.path.toLowerCase().substr(-3) === 'jpg'
          || obj.path.toLowerCase().substr(-4) === 'jpeg'
          || obj.path.toLowerCase().substr(-3) === 'png'
          || obj.path.toLowerCase().substr(-3) === 'svg'
          || obj.path.toLowerCase().substr(-3) === 'gif'
        )
      ) {
        return true;
      }
      if (this.bestandsFormat === 'docs'
        && (
          obj.path.toLowerCase().substr(-3) === 'doc'
          || obj.path.toLowerCase().substr(-4) === 'docx'
        )
      ) {
        return true;
      }
      if (this.bestandsFormat === 'excel'
        && (
          obj.path.toLowerCase().substr(-3) === 'xls'
          || obj.path.toLowerCase().substr(-4) === 'xlsx'
        )
      ) {
        return true;
      }
      if (this.bestandsFormat === 'overige'
        && obj.path.toLowerCase().substr(-3) !== 'xls'
        && obj.path.toLowerCase().substr(-4) !== 'xlsx'
        && obj.path.toLowerCase().substr(-3) !== 'doc'
        && obj.path.toLowerCase().substr(-4) !== 'docx'
        && obj.path.toLowerCase().substr(-3) !== 'jpg'
        && obj.path.toLowerCase().substr(-4) !== 'jpeg'
        && obj.path.toLowerCase().substr(-3) !== 'png'
        && obj.path.toLowerCase().substr(-3) !== 'svg'
        && obj.path.toLowerCase().substr(-3) !== 'gif'
        && obj.path.toLowerCase().substr(-3) !== 'xml'
        && obj.path.toLowerCase().substr(-3) !== 'msg'
        && obj.path.toLowerCase().substr(-3) !== 'txt'
        && obj.path.toLowerCase().substr(-3) !== 'pdf'
      ) {
        return true;
      }
      return false;
    },
    dateFilter(obj) {
      if (this.dateStart && Date.parse(this.dateStart) > Date.parse(obj.modified)) {
        return false;
      }
      if (this.dateEnd && Date.parse(this.dateEnd) < Date.parse(obj.modified)) {
        return false;
      }
      return true;
    },
    searchFilter(obj) {
      const trimmedSearch = this.searchName;
      if (obj.path.toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (trimmedSearch === null) {
        return true;
      }
      return false;
    },
    moveFile() {
      this.searching = true;
      this.sdk.moveArchiveFile(
        this.currentPort,
        encodeURI(this.currentFile),
        this.newport,
        (response) => {
          if (response.status === 200) {
            this.getFiles();
            this.moveFileModal = false;
            this.tooltipText = 'Bestand verplaatst.';
          } else {
            this.tooltipText = 'Fout bij verplaatsen bestand. Kan bestand niet naar zijn eigen archief verplaatsen.';
          }
          this.$store.state.confirm.toggle({
            text: this.tooltipText,
            title: 'Verplaatsen bestand',
            alert: true,
            confirmText: 'Terug',
            cb: () => {},
          });
        },
      );
    },
    moveArchive() {
      this.searching = true;
      this.sdk.moveArchiveFiles(this.currentPort, this.newport, (response) => {
        if (response.status === 200) {
          this.moveArchiveModal = false;
          this.$refs.search.value = this.newport;
          this.search = this.newport;
          this.getFiles();
          this.tooltipText = 'Archief verplaatst.';
        } else {
          this.tooltipText = 'Fout bij verplaatsen archief. Kan archief niet naar zichzelf verplaatsen.';
          this.searching = false;
        }
        this.$store.state.confirm.toggle({
          text: this.tooltipText,
          title: 'Verplaatsen archief',
          alert: true,
          confirmText: 'Terug',
          cb: () => {},
        });
      });
    },
    getFiles() {
      if (this.search === '') {
        return;
      }
      this.currentPort = this.search;
      this.searching = true;
      this.sdk.getArchiveFiles(this.currentPort, (response) => {
        if (response.status === 200) {
          this.searching = false;
          for (let i = 0; i < response.data.length; i += 1) {
            const parts = decodeURI(response.data[i].path).split('-');
            parts.shift();
            response.data[i].uploaded = Number(parts.shift());
            response.data[i].cleanPath = parts.join('-');
          }
          this.files = orderBy(response.data, ['uploaded'], ['desc']);
        }
      });
    },
    download(path) {
      this.sdk.getArchiveFile(this.currentPort, encodeURI(path));
    },
    deleteFile(path) {
      this.$store.state.confirm.toggle({
        title: 'Bestand verwijderen',
        text: 'Weet u zeker dat u dit bestand wilt verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteArchiveFile(
              this.currentPort,
              encodeURI(path),
              () => {
                this.getFiles();
              },
            );
          }
        },
      });
    },
    updateSearch() {
      this.currentPage = 0;
      this.search = this.$refs.search.value;
      if (this.currentPort !== this.search) {
        this.files = [];
        this.currentPort = '';
      }
    },
    uploadFiles() {
      this.sdk.uploadArchiveFile(
        this.currentPort,
        this.$refs.files.files,
        (response) => {
          if (response.status === 200) {
            this.getFiles();
          } else {
            this.$store.state.confirm.toggle({
              text: 'Fout met uploaden. Wij accepteren alleen afbeeldingen en pdf bestanden',
              title: 'Uploaden bestand',
              alert: true,
              confirmText: 'Terug',
              cb: () => {},
            });
          }
        },
        this.port,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  table {
    table-layout:fixed;
  }
  .menubar {
    height: 40px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    padding: 2px;
  }
  input.searchbar {
    width: 170px;
    border-top-left-radius: 4px !important;
  }
  .datebar {
    width: 120px;
    float: left;
    margin-right: 3px;
    padding: 9px;
    border-radius: 0;
  }
  .msg {
    border-radius: 0;
    margin: 0;
  }
  .card {
    overflow: hidden;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  .noresults {
    width: 100%;
    height: auto;
    padding: 100px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 20px;
    }
  }
</style>
